export default Object.freeze({
  list: [],
  info: {},
  reportLinks: {},
  excelData: {},
});
